import { useState } from "react";

function Login({ onLogin }) {
  const [name, setName] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!name.trim()) {
      alert("Please enter your name.");
      return;
    }

    localStorage.setItem("brightPathwayStudent", name.trim());
    onLogin(name.trim());
  };

  return (
    <div className="login-page">
      <div className="floating-shape shape-one"></div>
      <div className="floating-shape shape-two"></div>
      <div className="floating-shape shape-three"></div>

      <div className="login-card">
        <p className="mini-badge">🌟 Welcome to Bright Pathway 🌟</p>
        <h1 className="login-title">Let’s Learn & Play!</h1>
        <p className="login-text">
          Enter your name to start your fun learning adventure.
        </p>

        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Type your name here"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="login-input"
          />
          <button type="submit" className="login-button">
            Start My Journey 🚀
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;